import { defaultTo } from "lodash";
import { IVisitSalesItemPublicModel, VisitSalesItemPublicModel } from ".";

export interface IEstimateSalesItemModel extends IVisitSalesItemPublicModel {
    estimateSalesItemId: number,
    estimateId: number
    salesItemId: number;
    salesItemOptionId: number;
    salesPackageId: number | undefined;
    parentEstimateSalesItemId: number | undefined;
    salesPlanId: number | undefined;
    salesPlanName: string | undefined;
}

export class EstimateSalesItemModel extends VisitSalesItemPublicModel implements IEstimateSalesItemModel {
    estimateSalesItemId: number;
    estimateId: number;
    salesItemId: number;
    salesItemOptionId: number;
    salesPackageId: number | undefined;
    parentEstimateSalesItemId: number | undefined;
    salesPlanId: number | undefined;
    salesPlanName: string | undefined;

    constructor(params: IEstimateSalesItemModel) {
        super(params);
        this.estimateSalesItemId = params.estimateSalesItemId;
        this.estimateId = params.estimateId;
        this.salesItemId = defaultTo(params.salesItemId, 0);
        this.salesItemOptionId = defaultTo(params.salesItemOptionId, 0);
        this.salesPackageId = params.salesPackageId;
        this.parentEstimateSalesItemId = params.parentEstimateSalesItemId;
        this.salesPlanId = params.salesPlanId;
        this.salesPlanName = params.salesPlanName;
    }
}
